import type { MarketingSection } from '@mc/api'
import { useStaticData } from '@mc/static-data-react'
import { TRENDING } from 'libs/utils/categories'
import { getMarketingRow } from 'libs/utils/marketingRows'

export const useTrendingRow = () => {
  const { marketingRows } = useStaticData<{
    marketingRows?: MarketingSection[]
  }>()

  return getMarketingRow(marketingRows, TRENDING)
}

export const useHasCatalogExplorer = () => !!useTrendingRow()
